export {};
//# sourceMappingURL=vci-interfaces.js.map